import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import { Button } from '../../../shared/_form';
import { tradeCancelModal } from '../../../../constants/modals';
import CancelTradeRequestModal from '../CancelTradeRequestModal';
import Immutable from 'immutable';

const TradeOffersRequestedMobile = ({ tradeOffersRequested, onHandleShowTradeAcceptModal }) => {
  return (
    <Accordion accordion={ false }>
      { tradeOffersRequested.valueSeq().map((tradeOfferRequested) => (
        <AccordionItem key={ tradeOfferRequested.get('id') }>
          <AccordionItemTitle>
            <div className='u-position-relative'>
              <div>
                <div className={ 'accordion-header__title' }>Receiver</div>
                <div className={ 'accordion-header__item' }>{tradeOfferRequested.getIn(['receiver', 'name'])}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Offered Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferRequested.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferRequested.getIn(['offeredAppointment', 'from']))}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Requested Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferRequested.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferRequested.getIn(['requestedAppointment', 'from']))}</div>
              </div>
              <div className='accordion__arrow' role='presentation' />
            </div>
          </AccordionItemTitle>
          <AccordionItemBody>
            <div>
              <div className={ 'accordion-header__title' }>Office</div>
              <div className={ 'accordion-header__item' }>{tradeOfferRequested.getIn(['requestedAppointment', 'office', 'name'])}</div>
            </div>
            <div>
              <div className={ 'accordion-header__title' }>Status</div>
              <div className={ 'accordion-header__item trade-post__trade-status--pending' }>{tradeOfferRequested.get('status')}</div>
            </div>
            <div className={ 'accordion-post__buttons' }>
              <Button className='accordion-post__cancel-button'
                onClick={ onHandleShowTradeAcceptModal(tradeCancelModal(tradeOfferRequested.get('id'))) }
              >
                Cancel
              </Button>
          </div>
          </AccordionItemBody>
          <CancelTradeRequestModal id={ tradeCancelModal(tradeOfferRequested.get('id')) } tradeOfferId={ tradeOfferRequested.get('id') } />
        </AccordionItem>
      ))}
    </Accordion>

  );
};

TradeOffersRequestedMobile.propTypes = {
  onHandleShowTradeAcceptModal: PropTypes.func.isRequired,
  tradeOffersRequested: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default TradeOffersRequestedMobile;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/pending/TradeOffersRequestedMobile.jsx